<template>
  <div>
    <div class="ap-gallery">
      <div
        class="position-relative ap-gallery__item"
        v-for="image in images"
        :key="image.id"
        @click="handleImage(image.fullPath)">
          <img :src="image.fullPath">
      </div>
    </div>
    <Lightbox
      :visible="visible"
      :imgs="imgUrls"
      :index="index"
      @hide="handleImage('')"/>
  </div>
</template>

<script>
import Lightbox from 'vue-easy-lightbox'

export default {
  name: 'ApGallery',
  props: {
    images: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Lightbox
  },
  data () {
    return {
      visible: false,
      index: 0
    }
  },
  computed: {
    imgUrls: function () {
      let urls = []
      this.images.forEach(item => {
        urls.push(item.originPath)
      })
      return urls
    }
  },
  methods: {
    handleImage (url) {
      if (url === '') {
        this.visible = false
        return true
      }
      this.images.forEach((item, index) => {
        if (item.fullPath === url) {
          this.index = index
        }
      })
      this.visible = !this.visible
    }
  }
}
</script>

<style scoped lang="scss">
.ap-gallery {

  &__item {
    overflow: hidden;
    width: 60px;
    height: 50px;
    cursor: pointer;
    margin-bottom: 12px;
    margin-right: 12px;
    display: inline-block;

    img {
      width: auto;
      height: auto;
    }
  }
}
.modal {
  left: 50px!important;
}
</style>



// WEBPACK FOOTER //
// ApGallery.vue?29a2a801